import React from "react";
import { VstButton, VstDropdown } from "vstui";
import PropTypes from "prop-types";

export default class EditDeckButtons extends React.Component {
  render() {
    if (this.props.show) {
      const { edit, destroy, target } = this.props;
      return (
        <div className="deck-top-container">
          <VstButton
            className="show-on-hover trash no-button"
            title={i18n.t("reader.flashcards.delete")}
            onClick={destroy}
          >
            <span className="offScreen">
              {i18n.t("reader.flashcards.delete")}
            </span>
          </VstButton>
          <VstButton
            className="show-on-hover edit no-button"
            title={i18n.t("reader.flashcards.edit")}
            onClick={edit}
          >
            <span className="offScreen">
              {i18n.t("reader.flashcards.edit")}
            </span>
          </VstButton>
          <VstDropdown
            horizontal="right"
            className="edit-dropdown"
            target={target()}
            headerTitle={i18n.t("reader.panels.figures")}
          >
            <VstDropdown.Item className={""} onClick={edit}>
              {i18n.t("reader.flashcards.edit")}
            </VstDropdown.Item>
            <VstDropdown.Item className={""} onClick={destroy}>
              {i18n.t("reader.flashcards.delete")}
            </VstDropdown.Item>
          </VstDropdown>
        </div>
      );
    }
    return null;
  }
}
